import { getThemeImage } from './theme-utils'
import _ from 'lodash'
/**
 * Preloads media into the cache so that it loads instantly when needed in later flows.
 * @param {array} - The array of media urls (strings) to be preloaded into the cache
 */
export function cacheMedia(array) {
  let list = []
  array.forEach(mediaSource => {
    let img = new Image()
    img.onload = img.onerror = img.onabort = () => {
      if (list.includes(img)) {
        list.splice(list.indexOf(img), 1)
      }
    }
    list.push(img)
    img.src = mediaSource
  })
}

export function cacheFirstCardFirstFooterAndAllIcons(themeList) {
  // if in weird cases themeList does not have what we want (e.g. service error resulting in empty array)
  // do nothing
  if (!_.get(themeList, '[0].id')) {
    return
  }
  const firstCard = getThemeImage(themeList[0].id, 'card')
  const firstFooter = getThemeImage(themeList[0].id, 'footer')
  const allIcons = themeList.map((item, index) =>
    getThemeImage(themeList[index].id, 'icon')
  )
  const arrayOfMediaContentToBeLoaded = [firstCard, ...allIcons, firstFooter]
  cacheMedia(arrayOfMediaContentToBeLoaded)
}
